import SolicituPago from "@/api/services/finanzas/SolicitudPagoService"
import Vue from "vue"

const state = () => ({
    solicitudes: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "-fecha_solicitud",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})



const getters = {
    SOLICITUDES: state => {
        return state.solicitudes
    },
    SOLICITUDES_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_SOLICITUDES: (state, payload) => {
        state.solicitudes = payload
    },

    SET_SOLICITUDES_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_SOLICITUD: (state, payload) => {
        state.solicitudes.push(payload)
    },

    UPDATE_SOLICITUD: (state, payload) => {
        state.solicitudes = state.solicitudes.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_SOLICITUD: (state, payload) => {
        state.solicitudes = state.solicitudes.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_SOLICITUDES: async ({ commit, state }, { filter, solicitudEstado, customfilter }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }

            if (solicitudEstado === "5") {
                // customfilter = `fecha_solicitud=${new Date().toISOString().substr(0, 10)}`
                customfilter = { fecha_solicitud: new Date().toISOString().substr(0, 10) }
            }

            if (solicitudEstado === "7") {
                // customfilter = `estado=2&fecha_pago=${new Date().toISOString().substr(0, 10)}`
                customfilter = {
                    estado: 2,
                    fecha_pago: new Date().toISOString().substr(0, 10)
                }
            }

            let { data, status, headers } = await SolicituPago.get({
                filter,
                solicitudEstado,
                ...customfilter,
                ...pagination
            })
            if (status === 200) {
                commit("SET_SOLICITUDES", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las solicitudes, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_SOLICITUDES: async ({ commit }) => {
        try {
            let { data, status } = await SolicituPago.get()
            if (status === 200) {
                commit("SET_SOLICITUDES", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_SOLICITUDES: async ({ commit}) => {
        try {
            let { data, status } = await SolicituPago.getAllRecords()
            if (status === 200) {
                commit("SET_SOLICITUDES", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las solicitudes, inténtelo nuevamente"
            })
        }
    },

    LOAD_SOLICITUD_DETAILS: async ({ commit }, payload) => {
        try {
            let { data, status } = await SolicituPago.loadDetails(payload)
            if (status === 200) {
                commit("UPDATE_SOLICITUD", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar los detalles de la solicitud, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_SOLICITUD: async ({ commit }, payload) => {
        try {
            let { data, status } = await SolicituPago.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_SOLICITUD", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial de la solicitud, inténtelo nuevamente"
            })
        }
    },

    PAY_SOLICITUD: async ({ commit }, payload) => {
        try {
            let { data, status } = await SolicituPago.pay(payload)
            if (status === 200) {
                commit("UPDATE_SOLICITUD", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La solicitud ha sido pagada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido pagar la solicitud, inténtelo nuevamente"
            })
        }
    },

    ADD_SOLICITUD: async ({ commit }, payload) => {
        try {
            let { data, status } = await SolicituPago.post(payload)
            if (status === 201) {
                commit("ADD_SOLICITUD", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "La solicitud ha sido agregda satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar la solicitud, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_SOLICITUD: async ({ commit }, payload) => {
        try {
            let { data, status } = await SolicituPago.put(payload)
            if (status === 200) {
                commit("UPDATE_SOLICITUD", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La solicitud ha sido modificada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar la solicitud, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_SOLICITUD: async ({ commit }, payload) => {
        try {
            let { status, data } = await SolicituPago.delete(payload)
            if (status === 204) {
                commit("DELETE_SOLICITUD", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "La solicitud ha sido eliminada satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_SOLICITUD", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "La solicitud ha sido deshabilitada satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar la solicitud, inténtelo nuevamente"
            })
        }
    },

    LOAD_MONTOS_TOTAL: async () => {
        try {
            let { status, data } = await SolicituPago.getMontosTotal()
            if (status === 200) {
                return data
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el monto total de las solicitudes, inténtelo nuevamente"
            })
        }
    },

    EXPORT: async (store, payload) => {
        try {
            // let { status, data } = await SolicituPago.export(payload)
            let { status, data } = await SolicituPago.export(payload)
            if (status === 200) {
               return data
            }
        } catch (error) {
            console.log(error)
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "Blablablababababaa"
            })
        }
    },

    DOWNLOAD_SOLICITUD_FACTURA: async (store, payload) => {
        try {
            console.log(payload)

            let { data, status } = await SolicituPago.downloadFactura(payload)
            if (status === 200) {
                return data
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido descargar la factura para esta solicitud de pago"
            })
        }
    },

    DOWNLOAD_SOLICITUD_COMPROBANTE: async (store, payload) => {
        try {
            let { data, status } = await SolicituPago.downloadComprobante(payload)
            if (status === 200) {
                return data
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido descargar el comprobante para esta solicitud de pago"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
